module.exports = __webpack_public_path__ + "img/logo.19b1085f.png";